import { render, staticRenderFns } from "./RestoreBackup.vue?vue&type=template&id=1fb9f83c&scoped=true&"
import script from "./RestoreBackup.vue?vue&type=script&lang=js&"
export * from "./RestoreBackup.vue?vue&type=script&lang=js&"
import style0 from "./RestoreBackup.vue?vue&type=style&index=0&id=1fb9f83c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb9f83c",
  null
  
)

export default component.exports